import { render, staticRenderFns } from "./questionnare-data.vue?vue&type=template&id=10a922f2&scoped=true&"
import script from "./questionnare-data.vue?vue&type=script&lang=js&"
export * from "./questionnare-data.vue?vue&type=script&lang=js&"
import style0 from "./questionnare-data.vue?vue&type=style&index=0&id=10a922f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a922f2",
  null
  
)

export default component.exports